import React from 'react';
import ListViewContainer from '../shared/ListViewContainer';
import Box from 'components/elements/Box';
import P from 'components/elements/p';
import RadioGroup, {
  IRadioGroupOptionsItem,
} from 'components/customlists/ShareList/RadioGroup';
import CopyInvitationUrl from 'components/customlists/ShareList/CopyInvitationUrl';
import useInvitationUrl from './useInvitationUrl';

interface IFollowerShareListProps {
  close: () => void;
  baseUrl?: string;
}

const FollowerShareList: React.FC<IFollowerShareListProps> = (props) => {
  const { close, baseUrl } = props;

  const invitationFullUrl = useInvitationUrl({
    role: 'follower',
  });

  const radioGroupOptions: IRadioGroupOptionsItem[] = [
    {
      label: 'Viewers',
      value: 'follower',
      description: 'They can follow and share this list.',
      disabled: false,
    },
    {
      label: 'Curators',
      value: 'admin',
      description: 'You need curator access to invite new curators.',
      disabled: true,
    },
  ];

  return (
    <ListViewContainer title="Share" rejectedMessage={undefined} close={close}>
      <Box>
        <P>Who would you like to share this list with?</P>
        <RadioGroup
          name="share-list-invitation"
          options={radioGroupOptions}
          selectedOption={'follower'}
        />
        <Box display="flex" justifyContent="center">
          <P>Copy and paste the link below in emails or chats</P>
        </Box>
        <CopyInvitationUrl link={baseUrl || invitationFullUrl} />
      </Box>
    </ListViewContainer>
  );
};

export default FollowerShareList;
